import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import { Text } from "@fluentui/react-components";

import { FontSizeRecord, M365PulseTextProps } from "./M365PulseText.types";

const M365PulseTextBase: FunctionComponent<M365PulseTextProps> = (props: M365PulseTextProps) => {
    const { fontSize, size, children, ...restProps } = props;
    const presetSize = fontSize ? FontSizeRecord[fontSize] : size;

    return (
        <Text size={presetSize} truncate wrap={false} {...restProps}>
            {children}
        </Text>
    );
};

export const M365PulseText = observer(M365PulseTextBase);
M365PulseText.displayName = "M365PulseText";
